
import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalBasic from '~/components/common/modals/common/ModalBasic.vue'
import Icon from '~/components/common/icon/Icon.vue'
import { manageWidgets } from '~/lib/utils/utils'

@Component({
  components: {
    ModalBasic,
    Icon
  }
})
export default class AutoApplicationModalSuccess extends Vue {
  @Prop({ type: Boolean, default: true }) readonly showCloseCross: boolean
  @Prop({ type: Boolean, default: true }) readonly header: boolean

  mounted() {
    manageWidgets(true)
  }

  beforeDestroy() {
    manageWidgets(false)
  }

  get successImageSrc() {
    return require('~/components/common/modals/auto-application-modal/success.svg?inline').default
  }
}
